function initializeMasonry(masonryContainer) {
	const gridItems = masonryContainer.querySelectorAll('.grid-item');
	let remValue = getComputedStyle(document.body).getPropertyValue('--wp--custom--spacing--gap').trim();
	remValue = remValue.replace('rem', '');
	const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
	const gutter = parseFloat(remValue) * rootFontSize || 30;

	gridItems.forEach((gridItem) => {
		gridItem.style.marginBottom = `${gutter}px`;
	});

	import('masonry-layout').then((MasonryModule) => {
		const Masonry = MasonryModule.default;
		new Masonry(masonryContainer, {
			itemSelector: '.grid-item',
			gutter: gutter
		});
	});
}

document.addEventListener('DOMContentLoaded', () => {
	const masonryContainers = document.querySelectorAll('.is-masonry-loop');

	if (masonryContainers.length > 0) {
		import('masonry-layout').then(() => {
			// Initialize Masonry for existing containers
			Array.from(masonryContainers).forEach(initializeMasonry);

			// Use a MutationObserver to detect new containers
			const observer = new MutationObserver((mutations) => {
				mutations.forEach((mutation) => {
					if (mutation.addedNodes) {
						mutation.addedNodes.forEach((node) => {
							if (node.nodeType === 1 && node.matches('.is-masonry-loop')) {
								initializeMasonry(node);
							}
						});
					}
				});
			});

			// Attach observer to the body and look for childList changes
			if (document.body) {
				observer.observe(document.body, { childList: true, subtree: true });
			}
		});
	}
});
